import { useMemo } from "react"
import type { BasketByType } from "lib/apollo/types"
import { useBasket } from "lib/apollo/hooks"
import { getBasketByType } from "utils/getBasketByType"

export const useBasketByType = (): BasketByType => {
  const basket = useBasket()

  return useMemo(() => getBasketByType(basket), [basket])
}
